import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 删除邮件模板
const delTemplate = obj => new Promise((resolve, reject) => {
    const {
        id,
        token
    } = obj;
    request({
        url: apis.mail_template_del + '?id=' + id + '&token=' + token
    }).then(res => {
        resolve(res);
    })
});

// 修改邮件模板
const modifyTemplate = obj => new Promise((resolve, reject) => {
    const {
        id,
        mailTemplateForm,
        token
    } = obj;
    request({
        url: apis.mail_template_modify + '?id=' + id + '&token=' + token,
        data: mailTemplateForm
    }).then(res => {
        resolve(res);
    })
});

// 邮件模板列表
const findByName = obj => new Promise((resolve, reject) => {
    const {
        token,
        queryForm
    } = obj;
    request({
        url: apis.mail_template_find + '?token=' + token,
        data:queryForm
    }).then(res => {
        resolve(res);
    })
});

// 创建邮件模板
const saveTemplate = obj => new Promise((resolve, reject) => {
    const {
        mailTemplateForm,
        token
    } = obj;
    request({
        url: apis.mail_template_save + '?token=' + token,
        data: mailTemplateForm
    }).then(res => {
        resolve(res);
    })
});

export default {
    delTemplate,
    modifyTemplate,
    findByName,
    saveTemplate
}



// WEBPACK FOOTER //
// ./src/service/mail_template_api.js